/**
 * 号码补零标准化：1-49 补零为两位，其它保留原样
 */
export function normalizeBallNum(val) {
  const s = String(val == null ? '' : val).trim()
  if (!s) return ''
  const n = parseInt(s, 10)
  if (Number.isNaN(n) || n < 1 || n > 49) return s.length <= 2 ? s.padStart(2, '0') : s
  return n < 10 ? `0${n}` : String(n)
}

/**
 * 逗号/中文逗号分割
 */
export function splitCsv(s) {
  if (s == null || s === '') return []
  return String(s)
    .split(/[,，]/)
    .map(x => x.trim())
    .filter(Boolean)
}

/**
 * API 波色标准化（未知返回空字符串）
 */
export function normalizeApiTone(c) {
  if (c == null || typeof c !== 'string') return ''
  const x = c.trim().toLowerCase()
  if (x === 'red' || x === 'blue' || x === 'green') return x
  return ''
}

/**
 * 历史波色标准化（未知返回 'blue'）
 */
export function normalizeHistoryTone(c) {
  if (c == null || typeof c !== 'string') return 'blue'
  const x = c.trim().toLowerCase()
  if (x === 'red' || x === 'blue' || x === 'green') return x
  return 'blue'
}

/**
 * 查波色表返回 'red' | 'blue' | 'green'
 * @param {string} val 球号
 * @param {{ red: string[], blue: string[], green: string[] }} tables 波色号码表
 */
export function waveTone(val, tables) {
  const n = normalizeBallNum(val)
  if (tables.red.includes(n)) return 'red'
  if (tables.blue.includes(n)) return 'blue'
  if (tables.green.includes(n)) return 'green'
  return 'blue'
}

/**
 * 球对象工厂
 */
export function createBall(value, zodiac, element, tone) {
  return {
    value: normalizeBallNum(value),
    zodiac: zodiac || '',
    element: element || '',
    tone: tone || ''
  }
}
